import './AppLevelErrorBoundary.css';

import { Button } from '@vmware-react/clarity';
import React from 'react';
import { l10n } from '../i18n/i18nUtil';

export default class AppLevelErrorBoundary extends React.Component<
  {},
  { hasError: boolean }
> {
  public static getDerivedStateFromError() {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }
  constructor(props: {}) {
    super(props);
    this.state = { hasError: false };
  }

  public componentDidCatch(error: any, errorInfo: any) {
    // You can also log the error to an error reporting service
    /* eslint-disable-next-line */
    console.log('AppLevelErrorBoundary : caught error', error, errorInfo);
  }

  public render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <div className="app-level-error-boundary">
          <span className="emoji" role="img" aria-label="Sad emotion">
            😕
          </span>
          <span className="message">
            {l10n('components.withAppRoot.unexpectedError')}
          </span>

          <a href="/">
            <Button class="primary">{l10n('home')}</Button>
          </a>
        </div>
      );
    }

    return this.props.children;
  }
}
